import { UserPermisions, UserRole } from "../../utils/types/user";
import { useAppSelector } from "../useRedux";

// FUNCTION TO CHECK IF LOGGED IN USER HAS ROLE
export const useDoesUserHaveRole = (roles: UserRole[]) => {
    const { practice } = useAppSelector((state) => state.userPractice);

    if (!practice?.roles || !roles?.length) {
        return false;
    }

    return roles.some((role) => practice.roles.includes(role));
};

// FUNCTION TO CHECK IF LOGGED IN USER HAS PERMISSION
export const useDoesUserHavePermission = (permissions: UserPermisions[]) => {
    const { practice } = useAppSelector((state) => state.userPractice);

    if (!practice?.permissions || !permissions?.length) {
        return false;
    }

    return permissions.some((permission) =>
        practice.permissions.includes(permission)
    );
};
